import React from 'react';
import Slick from 'react-slick';
import NewsStoryCard from '../../desktop/NewStoryCard';
import NewsStoryCardMobile from '../../mobile/NewStoryCard';
import Listingheader from '../../../routes/home/components/common/ListingheaderV2';
import s from './PoliticalLeadersTimeline.scss';

const NextArrow = props => (
  <span {...props} className={`btn next ${props.className}`}>
    <i />
  </span>
);

const PrevArrow = props => (
  <span {...props} className={`btn prev ${props.className}`}>
    <i />
  </span>
);
const settings = {
  dots: true,
  slidesToShow: 5,
  slidesToScroll: 5,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  infinite: false,
};

class PoliticalLeadersTimeline extends React.Component {
  render() {
    const { isWapView, sectionData, name } = this.props;
    return (
      <div className={`${s.plTimelineWrap} slick_UI`}>
        {name && <Listingheader headingname={name} />}
        <div className={s.plTimeline}>
          {!isWapView && (
            <Slick {...settings}>
              {sectionData &&
                Array.isArray(sectionData) &&
                sectionData.length > 0 &&
                sectionData.map(item => (
                  <section className={s.cardWrap}>
                    <div className={s.year}>{item?.term}</div>
                    <NewsStoryCard
                      title={item.name}
                      msid={item.id}
                      syn={item.party}
                      cardType="card_26"
                      synStyle={{
                        color: item.color,
                      }}
                      target="_self"
                    />
                  </section>
                ))}
            </Slick>
          )}
          {isWapView &&
            sectionData &&
            Array.isArray(sectionData) &&
            sectionData.length > 0 &&
            sectionData.map(item => (
              <section className={s.cardWrap}>
                <div className={s.year}>{item?.term}</div>
                <NewsStoryCardMobile
                  title={item.name}
                  msid={item.id}
                  syn={item.party}
                  cardType="card_20"
                  synStyle={{
                    color: item.color,
                  }}
                  target="_self"
                />
              </section>
            ))}
        </div>
      </div>
    );
  }
}

export default PoliticalLeadersTimeline;
